import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, createStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
  lobbyPeersKeySelector,
  raisedHandLengthSelector,
} from "../../helpers/Selectors";
import RoomContext from "../../context/RoomContext";
import { withStyles } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import FullScreenIcon from "@material-ui/icons/Fullscreen";
import FullScreenExitIcon from "@material-ui/icons/FullscreenExit";
import Tooltip from "@material-ui/core/Tooltip";
import LinkIcon from "@material-ui/icons/Link";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import RecordIcon from "@material-ui/icons/FiberManualRecordOutlined";
import LiveIcon from "@material-ui/icons/LiveTvOutlined";
import StopIcon from "@material-ui/icons/StopOutlined";
import PlayIcon from "@material-ui/icons/PlayArrowOutlined";
import PauseIcon from "@material-ui/icons/PauseOutlined";
import Gesture from "@material-ui/icons/Gesture";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Badge from "@material-ui/core/Badge";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ChatIcon from "@material-ui/icons/ChatBubbleOutlineOutlined";
import Poll from "@material-ui/icons/PollOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import PeopleIcon from "@material-ui/icons/PeopleOutline";
import SecurityIcon from "@material-ui/icons/Security";
import Portrait from "@material-ui/icons/Portrait";
import ActionsIcon from "@material-ui/icons/MoreVert";
import GuardianNoteIcon from "../Management/Messaging/icons/GuardianNote";
import {
  setSettingsOpen,
  setStartLiveStreamingDialogOpen,
} from "../../actions/roomActions";
import { toggleWhiteBoard } from "../../actions/whiteBoardActions";
import {
  setToolTab,
  openToolArea,
  closeToolArea,
} from "../../actions/toolareaActions";
import * as noteManagementActions from "../../actions/Management/noteManagementActions";
import * as roomActions from "../../actions/roomActions";
import SubjectIcon from "@material-ui/icons/Subject";
import isElectron from "is-electron";

// Room seçenek menüsünden kayıt / canlı yayın UI'ını gizle
const SHOW_RECORD_AND_LIVE_STREAM_OPTIONS = false;

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    actionButton: {
      marginLeft: theme.spacing(1),
      "&.selected": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
        color: "#3289ef",
      },
    },
    actionsButton: {},
    customBadge: {
      backgroundColor: "#f3465a",
      color: "white",
    },
    activeIcon: {
      color: "#3289ef",
    },
    hamburgerMenuButton: {
      position: "fixed",
      right: 0,
      top: 20,
      color: "#fff",
      "&.hide": {
        display: "none",
      },
    },
  })
);

const PulsingBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#f3465a",
    "&::after": {
      position: "absolute",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: `3px solid #f3465a`,
      content: '""',
    },
  },
  "@keyframes ripple": {
    color: "#f3465a",
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const BottomRightControlBar = ({
  fullscreenEnabled,
  fullscreen,
  onFullscreen,
}) => {
  const intl = useIntl();
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { roomClient } = useContext(RoomContext);
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const me = useSelector((state) => state.me);
  const room = useSelector((state) => state.room);
  const webinar = useSelector((state) => state.room.webinar);
  const browser = useSelector((state) => state.me.browser);
  const unread = useSelector((state) => state.toolarea.unreadMessages);

  const unreadPrivateMessagesTotal = useSelector(
    (state) => state.toolarea.unreadPrivateMessagesTotal
  );

  const currentToolTab = useSelector((state) => state.toolarea.currentToolTab);
  const currentSurvey = useSelector((state) => state.survey.currentSurvey);
  const whiteBoardHasChanges = useSelector(
    (state) => state.whiteboard.whiteBoardHasChanges
  );
  const toolAreaOpen = useSelector((state) => state.toolarea.toolAreaOpen);
  const whiteBoardOpen = useSelector(
    (state) => state.whiteboard.whiteBoardOpen
  );
  const lobbyPeers = useSelector((state) => lobbyPeersKeySelector(state));
  const raisedHandCount = useSelector((state) =>
    raisedHandLengthSelector(state)
  );
  const canLock = useSelector((state) =>
    state.me.roles.some((role) =>
      state.room.permissionsFromRoles.CHANGE_ROOM_LOCK.includes(role)
    )
  );

  const canRecord = useSelector((state) =>
    state.me.roles.some((role) =>
      state.room.permissionsFromRoles.RECORD.includes(role)
    )
  );
  const hasWebinarPresenterPermission = useSelector((state) =>
    state.me.roles.some((role) =>
      state.room.permissionsFromRoles.MODERATE_WEBINAR.includes(role)
    )
  );

  const currentCall = useSelector((state) => state.call.currentCall);

  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [isTooltipCopied, setIsTooltipCopied] = useState(false);

  const handleActionMenuClick = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <Hidden smUp>
        <IconButton
          color="inherit"
          aria-label="Open Menu"
          onClick={() => {
            dispatch(openToolArea());
            raisedHandCount && dispatch(setToolTab("users"));
            lobbyPeers.length && dispatch(setToolTab("lobby"));
            unread && dispatch(setToolTab("chat"));
          }}
          className={classnames(classes.hamburgerMenuButton, {
            hide: toolAreaOpen ? true : false,
          })}
        >
          <PulsingBadge
            max={5000}
            classes={{ badge: classes.customBadge }}
            badgeContent={
              (webinar ? raisedHandCount : 0) + lobbyPeers.length + unread
            }
          >
            <MenuIcon />
          </PulsingBadge>
        </IconButton>
      </Hidden>

      <Hidden xsDown>
        <Tooltip
          placement="top"
          title={intl.formatMessage({
            id: "tooltip.participants",
            defaultMessage: "Show participants",
          })}
        >
          <span>
            <IconButton
              className={classnames(classes.actionButton, {
                selected:
                  toolAreaOpen && currentToolTab === "users" ? true : false,
              })}
              onClick={() => {
                if (!toolAreaOpen) {
                  dispatch(openToolArea());
                } else if (currentToolTab === "users") {
                  dispatch(closeToolArea());
                }
                dispatch(setToolTab("users"));
              }}
              size="small"
              disabled={whiteBoardOpen}
            >
              <PulsingBadge
                max={5000}
                classes={{ badge: classes.customBadge }}
                badgeContent={webinar ? raisedHandCount : 0}
              >
                <PeopleIcon />
              </PulsingBadge>
            </IconButton>
          </span>
        </Tooltip>
      </Hidden>

      <Hidden xsDown>
        {lobbyPeers.length > 0 && (
          <Tooltip
            placement="top"
            title={intl.formatMessage({
              id: "tooltip.lobby",
              defaultMessage: "Lobby",
            })}
          >
            <span>
              <IconButton
                className={classnames(classes.actionButton, {
                  selected:
                    toolAreaOpen && currentToolTab === "lobby" ? true : false,
                })}
                onClick={() => {
                  if (!toolAreaOpen) {
                    dispatch(openToolArea());
                  } else if (currentToolTab === "lobby") {
                    dispatch(closeToolArea());
                  }
                  dispatch(setToolTab("lobby"));
                }}
                size="small"
                disabled={whiteBoardOpen}
              >
                <PulsingBadge
                  classes={{ badge: classes.customBadge }}
                  badgeContent={lobbyPeers.length}
                >
                  <SecurityIcon />
                </PulsingBadge>
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Hidden>

      <Hidden xsDown>
        <Tooltip
          placement="top"
          title={intl.formatMessage({
            id: "label.chat",
            defaultMessage: "Chat",
          })}
        >
          <span>
            <IconButton
              className={classnames(classes.actionButton, {
                selected:
                  toolAreaOpen && currentToolTab === "chat" ? true : false,
              })}
              onClick={() => {
                if (!toolAreaOpen) {
                  dispatch(openToolArea());
                } else if (currentToolTab === "chat") {
                  dispatch(closeToolArea());
                }
                dispatch(setToolTab("chat"));
              }}
              size="small"
              disabled={whiteBoardOpen}
            >
              <PulsingBadge
                classes={{ badge: classes.customBadge }}
                max={5000}
                badgeContent={unreadPrivateMessagesTotal + unread}
              >
                <ChatIcon />
              </PulsingBadge>
            </IconButton>
          </span>
        </Tooltip>
      </Hidden>

      {window.config.showConferenceSurveyButton && (
        <Hidden xsDown>
          <Tooltip
            placement="top"
            title={intl.formatMessage({
              id: "label.survey",
              defaultMessage: "Survey",
            })}
          >
            <span>
              <IconButton
                className={classnames(classes.actionButton, {
                  selected:
                    toolAreaOpen && currentToolTab === "survey" ? true : false,
                })}
                onClick={() => {
                  if (!toolAreaOpen) {
                    dispatch(openToolArea());
                  } else if (currentToolTab === "survey") {
                    dispatch(closeToolArea());
                  }
                  dispatch(setToolTab("survey"));
                }}
                size="small"
                disabled={whiteBoardOpen}
              >
                {currentSurvey ? (
                  <PulsingBadge
                    classes={{ badge: classes.customBadge }}
                    variant="dot"
                    badgeContent=" "
                  >
                    <Poll />
                  </PulsingBadge>
                ) : (
                  <Poll />
                )}
              </IconButton>
            </span>
          </Tooltip>
        </Hidden>
      )}

      {window.config.showConferenceWhiteBoardButton && (
        <Tooltip
          placement="top"
          title={intl.formatMessage({
            id: "tooltip.whiteboard",
            defaultMessage: "White Board",
          })}
        >
          <span>
            <IconButton
              className={classnames(classes.actionButton, {
                selected: whiteBoardOpen,
              })}
              onClick={() => dispatch(toggleWhiteBoard())}
              size="small"
              disabled={toolAreaOpen}
            >
              {whiteBoardHasChanges ? (
                <PulsingBadge
                  classes={{ badge: classes.customBadge }}
                  variant="dot"
                  badgeContent=" "
                >
                  <Gesture />
                </PulsingBadge>
              ) : (
                <Gesture />
              )}
            </IconButton>
          </span>
        </Tooltip>
      )}

      <Tooltip
        placement="top"
        title={intl.formatMessage({
          id: "tooltip.moreActions",
          defaultMessage: "More",
        })}
      >
        <IconButton
          onClick={handleActionMenuClick}
          className={classes.actionButton}
          style={
            Boolean(actionMenuAnchorEl) === true
              ? { backgroundColor: "rgba(0, 0, 0, 0.04)" }
              : {}
          }
          size="small"
        >
          <ActionsIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="action-menu"
        anchorEl={actionMenuAnchorEl}
        keepMounted
        autoFocus={false}
        open={Boolean(actionMenuAnchorEl)}
        onClose={handleActionMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            borderRadius: "32px 32px 0px 32px",
          },
        }}
      >
        {((me.roles.includes("admin") && !webinar) ||
          (hasWebinarPresenterPermission && webinar)) &&
          window.config.showConferenceWebinarButton && (
            <MenuItem
              onClick={() => {
                handleActionMenuClose();
                roomClient.makeWebinar(!webinar);
              }}
            >
              <ListItemIcon>
                <Portrait className={webinar ? classes.activeIcon : null} />
              </ListItemIcon>
              <ListItemText
                primary={
                  !webinar
                    ? intl.formatMessage({
                        id: "room.makeWebinar",
                        defaultMessage: "Webinar",
                      })
                    : intl.formatMessage({
                        id: "label.cancel",
                        defaultMessage: "Cancel",
                      })
                }
              />
            </MenuItem>
          )}
        {SHOW_RECORD_AND_LIVE_STREAM_OPTIONS &&
          !isXs &&
          !window.config.autoRecord &&
          room.roomRecordingState === "stop" &&
          !room.liveStreamingNotificationStatus &&
          canRecord &&
          (browser.flag !== "edge" ||
            (browser.flag === "edge" &&
              browser.version &&
              Number(browser.version.substring(0, 2)) >= 83)) && (
            <MenuItem
              onClick={() => {
                handleActionMenuClose();
                roomClient.startRecording();
              }}
            >
              <ListItemIcon>
                <RecordIcon />
              </ListItemIcon>
              <ListItemText
                primary={intl.formatMessage({
                  id: "tooltip.recordMeeting",
                  defaultMessage: "Record Meeting",
                })}
              />
            </MenuItem>
          )}
        {SHOW_RECORD_AND_LIVE_STREAM_OPTIONS &&
          room.roomRecordingState === "recording" &&
          !window.config.autoRecord && (
          <MenuItem
            onClick={() => {
              handleActionMenuClose();
              roomClient.pauseRecording();
            }}
          >
            <ListItemIcon>
              <PauseIcon />
            </ListItemIcon>
            <ListItemText
              primary={intl.formatMessage({
                id: "tooltip.pauseRecording",
                defaultMessage: "Pause Recording",
              })}
            />
          </MenuItem>
        )}
        {SHOW_RECORD_AND_LIVE_STREAM_OPTIONS &&
          room.roomRecordingState === "pause" &&
          !window.config.autoRecord && (
          <MenuItem
            onClick={() => {
              handleActionMenuClose();
              roomClient.resumeRecording();
            }}
          >
            <ListItemIcon>
              <PlayIcon />
            </ListItemIcon>
            <ListItemText
              primary={intl.formatMessage({
                id: "tooltip.resumeRecording",
                defaultMessage: "Resume Recording",
              })}
            />
          </MenuItem>
        )}
        {SHOW_RECORD_AND_LIVE_STREAM_OPTIONS &&
          room.roomRecordingState === "recording" &&
          !window.config.autoRecord && (
          <MenuItem
            onClick={() => {
              handleActionMenuClose();
              roomClient.stopRecording();
            }}
          >
            <ListItemIcon>
              <StopIcon />
            </ListItemIcon>
            <ListItemText
              primary={intl.formatMessage({
                id: "tooltip.stopRecording",
                defaultMessage: "Stop Recording",
              })}
            />
          </MenuItem>
        )}
        {SHOW_RECORD_AND_LIVE_STREAM_OPTIONS &&
          !isXs &&
          !window.config.autoRecord &&
          !room.liveStreamingNotificationStatus &&
          room.roomRecordingState === "stop" &&
          canRecord &&
          (browser.flag !== "edge" ||
            (browser.flag === "edge" &&
              browser.version &&
              Number(browser.version.substring(0, 2)) >= 83)) && (
            <MenuItem
              onClick={() => {
                dispatch(
                  setStartLiveStreamingDialogOpen({
                    startLiveStreamingDialogOpen: true,
                  })
                );
                handleActionMenuClose();
              }}
            >
              <ListItemIcon>
                <LiveIcon />
              </ListItemIcon>
              <ListItemText
                primary={intl.formatMessage({
                  id: "tooltip.startLiveStream",
                  defaultMessage: "Start Live Stream",
                })}
              />
            </MenuItem>
          )}
        {SHOW_RECORD_AND_LIVE_STREAM_OPTIONS &&
          room.liveStreamingNotificationStatus &&
          canRecord &&
          !window.config.autoRecord && (
            <MenuItem
              onClick={() => {
                handleActionMenuClose();
                roomClient.stopRecording();
              }}
            >
              <ListItemIcon>
                <StopIcon />
              </ListItemIcon>
              <ListItemText
                primary={intl.formatMessage({
                  id: "tooltip.stopLiveStream",
                  defaultMessage: "Stop Live Streaming",
                })}
              />
            </MenuItem>
          )}
        {canLock && (
          <MenuItem
            onClick={() => {
              handleActionMenuClose();
              if (room.locked) {
                roomClient.unlockRoom();
              } else {
                roomClient.lockRoom();
              }
            }}
          >
            <ListItemIcon>
              {room.locked ? <LockIcon /> : <LockOpenIcon />}
            </ListItemIcon>
            <ListItemText
              primary={
                room.locked
                  ? intl.formatMessage({
                      id: "tooltip.unLockRoom",
                      defaultMessage: "Unlock room",
                    })
                  : intl.formatMessage({
                      id: "tooltip.lockRoom",
                      defaultMessage: "Lock room",
                    })
              }
            />
          </MenuItem>
        )}
        {roomClient.getDeviceFlag() !== "safari" && (
          <CopyToClipboard
            text={window.config.appUrl + roomClient.getRoomId()}
            onCopy={() => {
              setIsTooltipCopied(true);
              handleActionMenuClose();
            }}
          >
            <Tooltip
              open={isTooltipCopied}
              onClose={() => {
                setIsTooltipCopied(false);
              }}
              title={
                <h2>
                  {intl.formatMessage({
                    id: "room.copiedInvitationLink",
                    defaultMessage: "Copied",
                  })}
                </h2>
              }
              leaveDelay={1000}
            >
              <MenuItem>
                <ListItemIcon>
                  <LinkIcon />
                </ListItemIcon>
                <ListItemText
                  primary={intl.formatMessage({
                    id: "tooltip.copyInvitationLink",
                    defaultMessage: "Copy invitation link",
                  })}
                />
              </MenuItem>
            </Tooltip>
          </CopyToClipboard>
        )}
        <MenuItem
          onClick={() => {
            handleActionMenuClose();
            dispatch(setSettingsOpen({ settingsOpen: !room.settingsOpen }));
          }}
        >
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText
            primary={intl.formatMessage({
              id: "tooltip.settings",
              defaultMessage: "Show settings",
            })}
          />
        </MenuItem>
        <Hidden xsDown>
          {me.id.length > 8 && window.config.showConferenceAddNoteButton && (
            <MenuItem
              onClick={() => {
                handleActionMenuClose();
                dispatch(noteManagementActions.handleNewConferenceNote(true));
              }}
            >
              <ListItemIcon>
                <GuardianNoteIcon />
              </ListItemIcon>
              <ListItemText
                primary={intl.formatMessage({
                  id: "notes.addNote",
                  defaultMessage: "Add Note",
                })}
              />
            </MenuItem>
          )}
        </Hidden>
        <Hidden xsDown>
          {me.id === roomClient.getCreatorId() && !currentCall && (
            <MenuItem
              onClick={() => {
                handleActionMenuClose();
                dispatch(roomActions.setOfficialReportOpenGlobal(true));
              }}
            >
              <ListItemIcon>
                <SubjectIcon />
              </ListItemIcon>
              <ListItemText
                primary={intl.formatMessage({
                  id: "officialreport.openOfficialReport",
                  defaultMessage: "Open Official Report",
                })}
              />
            </MenuItem>
          )}
        </Hidden>
        {fullscreenEnabled && (
          <MenuItem
            onClick={() => {
              handleActionMenuClose();
              onFullscreen();
            }}
          >
            <ListItemIcon>
              {fullscreen ? <FullScreenExitIcon /> : <FullScreenIcon />}
            </ListItemIcon>
            <ListItemText
              primary={
                fullscreen
                  ? intl.formatMessage({
                      id: "tooltip.leaveFullscreen",
                      defaultMessage: "Leave fullscreen",
                    })
                  : intl.formatMessage({
                      id: "tooltip.enterFullscreen",
                      defaultMessage: "Enter fullscreen",
                    })
              }
            />
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

BottomRightControlBar.propTypes = {
  fullscreenEnabled: PropTypes.bool,
  fullscreen: PropTypes.bool,
  onFullscreen: PropTypes.func.isRequired,
};

export default BottomRightControlBar;
